import NavBar from "../../components/Navbar/Navbar";
import UploadData from "../../components/UploadData/UploadData";

function UploadDataPage() {
    return(
        <section className="UploadData">
            <NavBar />
            <UploadData />
        </section>
    )
}

export default UploadDataPage